import React, { useState } from "react";
import { Modal } from "antd";
import HeaderComponent from "components/card/HeaderComponent";

export default function HeaderModal( props ) {
 const { open, onClose, icon, width="600px", title, description, children, bgcolor, colorTheme, labelIcon, rightNav, footer, closable=true } = props;

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose} 
        footer={null}
        width={{
          xs: '98%',
          sm: '98%',
          md: '90%',
          lg: '70%',
        }}
        closable={closable}
        style={{ maxWidth: width, margin: "0 auto" }}
      >
        <div className="gradient-icon">
            <HeaderComponent
              icon={icon}
              title={title}
              description={description}
              bgcolor={bgcolor}
              colorTheme={colorTheme}
              labelIcon={labelIcon}
              rightNav={rightNav}
              footer={footer}
            >
              {children}
            </HeaderComponent>
        </div>
         
      </Modal>
    </>
  );
}
